class UserUtil {

    static transform(user){
        return {
            firstName:user.firstName,
            lastName:user.lastName,
            roleId:user.roleId,
            gender :user.gender,
            phone:user.phone,
            email:user.email,
            nearBy:user.nearBy,
            age:user.age,
            flatNumber:user.flatNumber,
            buildingName:user.buildingName,
            locality:user.locality,
            profileImage:"aaaa",
            isDisable: false,
            preferredProductPriceType : user.preferredProductPriceType,
            customerTypes : user.customerTypes,
            metaData : user.metaData,
            pinCode : user.pinCode,
            creditLimit : user.creditLimit,
            firstNameMarathi: user.firstNameMarathi,
            lastNameMarathi: user.lastNameMarathi,
            buildingNameMarathi: user.buildingNameMarathi,
            localityMarathi: user.localityMarathi,
            nearByMarathi: user.nearByMarathi,
            societyNameMarathi: user.societyNameMarathi,
            addresses : user.addresses,
            branchId : user.branchId || null,
        }
    }
}

export default UserUtil;
